import Carousel from "react-bootstrap/Carousel";
import './LatestCarousel.css';
import React, {Component} from "react";

class LatestCarousel extends Component {

    render() {
        let {appData} = this.props;
        let storiesList = appData.stories;
        let width = Math.floor(appData.isMobile ? 320 : 1400 * 0.77).toString();
        let height = Math.floor(appData.isMobile ? 320 : 400 * 0.77).toString();

        return (
            <Carousel controls={false} interval={5000} pauseOnHover={true}
                      style={{minHeight: height, minWidth: width, alignItems: 'center'}}>
                {storiesList.map(
                    function (story, idx) {
                        return (
                            <Carousel.Item>
                                <img
                                    src={appData.isMobile ? story.thumbnailSource : story.imageSource}
                                    alt={story.title}
                                    width="100%"
                                />
                                <Carousel.Caption style={{minHeight: height, minWidth: width}}>
                                    {(idx === 0 || idx=== 1) && (
                                    <div style={{fontSize: appData.isMobile ? '0.7rem' : '1.2rem', fontWeight: 'bold', textAlign: 'left'}}>
                                        <p style={{marginBottom: '0'}}>
                                            PPZEKAŻ 1% PODATKU
                                        </p>
                                        <p style={{marginBottom: '15vh'}}>
                                            KRS: 0000313847
                                        </p>
                                        <p style={{marginBottom: '0'}}>
                                            NUMER KONTA:
                                        </p>
                                        <p style={{marginBottom: '0'}}>
                                            27 1500 1634 1216 3005 4390 0000
                                        </p>
                                    </div>
                                    )}
                                </Carousel.Caption>
                            </Carousel.Item>);
                    }
                )}
            </Carousel>
        );
    }
}

export default LatestCarousel;